export default __webpack_public_path__ + "static/media/close2.8c044a65.svg";